import { URL_CONTENT, URL_DETAIL, URL_PLAYER, URL_SCREEN, URL_VIDEODETAIL, URL_WIDGET } from "../Components/Routes/Location";
import {
  TYPE_BANNER_BANNER,
  TYPE_BANNER_LIVE,
  TYPE_BANNER_LIVE_2,
  TYPE_BANNER_LIVE_VERTICAL,
  TYPE_BANNER_POSTER,
  TYPE_BANNER_PROGRESS,
  TYPE_BANNER_TEXT,
} from "../../../detail/src/Pages/DetailPage/PlaylistConstants";

export const ENVIRONMENT = process.env.REACT_APP_CORE_ENV;

export const USER_DEFAULT = "default-web";
export const WIDGET_TYPE_HIGHLIGHT = "DESTACADO";
export const WIDGET_TYPE_LIVE = "LIVE";
export const WIDGET_TYPE_LIVE_2 = "LIVE-2";
export const WIDGET_TYPE_LIVE_VERTICAL = "LIVEVERTICAL";
export const WIDGET_TYPE_GROUP_WIDGET = "GROUPWIDGET";
export const WIDGET_TYPE_GROUP_SCREEN = "SCREENWIDGET";
export const WIDGET_TYPE_CIRCULAR = "CIRCULAR";
export const WIDGET_TYPE_NEWS = "NEWS";
export const WIDGET_TYPE_FEATURED = "FEATURED";
export const WIDGET_TYPE_PROGRESS_V1 = "WIDGET_PROGRESS";
export const WIDGET_TYPE_HIGHLIGHT_V2 = "featured-v2";
export const WIDGET_TYPE_GRID = "GRID-V2";
export const WIDGET_TYPE_GRID_GROUP = "GRID_GROUP-V2";
export const WIDGET_TYPE_HTML = "HTML";
export const WIDGET_TYPE_LIVE_V2 = "DIRECTO-V2";
export const WIDGET_TYPE_POSTER = "POSTER-V2";
export const WIDGET_TYPE_PROGRESS = "WIDGET_PROGRESS_V2";
export const WIDGET_TYPE_BANNER = "BANNER-V2";
export const WIDGET_TYPE_FEATURED_SLIDER = "FEATURED_SLIDER";
export const WIDGET_TYPE_BANNER_SLIDER = "BANNER_SLIDER";
export const WIDGET_TYPE_BANNER_CLICK = "BANNER-CLICK";
export const WIDGET_TYPE_FEATURED_V2 = "FEATURED-V2";
export const WIDGET_TYPE_FILTER_LIST = "FILTER-LIST";
export const WIDGET_TYPE_LIST_SCREEN = "LIST-SCREEN";
export const WIDGET_TYPE_LIST_SCREEN_GRID = "LIST-SCREEN-GRID";
export const WIDGET_TYPE_LIST_SCREEN_V2 = "LIST-SCREEN-V2";
export const TYPE_BANNER_BANNER_LARGE = "BANNER_LARGE";
export const WIDGET_TYPE_FILTER = "FILTER";
export const TRANSITION_DURATION = "250";
export const LIMIT_ITEMS = "5";
export const WIDGET_TYPE_BANNER_CONTENT = "BANNER-CONTENT";

export const ORIGIN_SECTIONS = "ORIGIN_SECTIONS";
export const ORIGIN_HOME = "ORIGIN_HOME";

export const DATA_LOADING_STATUS_LOADED = "LOADED";
export const DATA_LOADING_STATUS_LOADING = "LOADING";

export const SWITCHER_WIDTH = 768;
// A partir de este ancho (inclusive hacia abajo) la cabecera y el menú usan la versión con ☰
export const MENU_MOBILE_WIDTH = 1024;

export const TVG = "TVG";

export const ANIMATION_GET_GOAL_PLAY = "playingAnimationGetGoal";
export const ANIMATION_GET_GOAL_ACHIEVEMENTS = "achievements";
export const ANIMATION_GET_GOAL_REWARDS = "rewards";
export const ACTIVE_CLASS = "active";
export const TYPE_REWARD_BADGE = "badge";
export const TYPE_REWARD_CERT = "cert";
export const TYPE_REWARD_HOOK = "hook";
export const TYPE_STRING = "string";

export const WIDGET_ACTION_PLAY = "PLAY";
export const WIDGET_ACTION_PLAYER = "PLAYER";
export const WIDGET_ACTION_DETAIL = "DETAIL";
export const WIDGET_ACTION_PLAYERDETAIL = "PLAYERDETAIL";
export const WIDGET_ACTION_FULL_LIST = "FULL_LIST";
export const WIDGET_ACTION_FULLLIST = "FULLLIST";
export const WIDGET_ACTION_SCREEN = "SCREEN";

export const KEYCLOAK_URI = process.env.REACT_APP_KC_BASE_URI + "/realms/" + process.env.REACT_APP_CORE_TENANT + "/protocol/openid-connect/token";
export const KEYCLOAK_USERINFO_URI = process.env.REACT_APP_KC_BASE_URI + "/realms/" + process.env.REACT_APP_CORE_TENANT + "/protocol/openid-connect/userinfo";
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const APPNAME = process.env.REACT_APP_CORE_TENANT;

export const PLAYER_SIMPLE_URI_PREFIX = "player/" + process.env.REACT_APP_REALM + "/simple";
export const PLAYER_SIMPLE_URI_SUFFIX = "/embed.js";
export const PLAYER_SIMPLE_URI_DETAIL_PARAMETER = "?detail=true";

export const FORM_STEPS = {
  LOGIN: "login",
  REGISTER: "register",
  RECOVER: "recover",
}

export const NON_DEACTIVABLE_KEYCLOAK_ROLES = ["user-master", "superuser"];

export const DEFAULT_AVATAR_ID = 13;

export const ROUTES_BY_WIDGET_ACTION = {
  [WIDGET_ACTION_PLAY]: {
    ROUTE: URL_PLAYER,
    TEXT: "seeMore",
    SHOW_BUTTONS: true,
  },
  [WIDGET_ACTION_PLAYER]: {
    ROUTE: URL_PLAYER,
    TEXT: "seeMore",
    SHOW_BUTTONS: true,
  },
  [WIDGET_ACTION_DETAIL]: {
    ROUTE: URL_VIDEODETAIL,
    TEXT: "seeDetail",
    SHOW_BUTTONS: true,
  },
  [WIDGET_ACTION_PLAYERDETAIL]: {
    ROUTE: URL_DETAIL,
    TEXT: "seeDetail",
    SHOW_BUTTONS: true,
  },
  [WIDGET_ACTION_FULL_LIST]: {
    ROUTE: URL_CONTENT + URL_WIDGET,
    TEXT: "seeDetail",
    SHOW_BUTTONS: false,
  },
  [WIDGET_ACTION_FULLLIST]: {
    ROUTE: URL_CONTENT + URL_WIDGET,
    TEXT: "seeDetail",
    SHOW_BUTTONS: false,
  },
  [WIDGET_ACTION_SCREEN]: {
    ROUTE: URL_SCREEN,
    TEXT: "seeDetail",
    SHOW_BUTTONS: false,
  },
};

export const ANDROID_DEVICES = ["Android"];
export const IOS_DEVICES = ["iPhone", "iPod", "iPad"];

export const DEVICE_IPHONE = "iPhone";
export const DEVICE_IPAD = "iPad";
export const DEVICE_IPOD = "iPod";
export const DEVICE_ANDROID = "Android";
export const DEVICE_IOS = "iOS";

export const DEVICES = {
  [DEVICE_ANDROID]: DEVICE_ANDROID,
  [DEVICE_IPHONE]: DEVICE_IOS,
  [DEVICE_IPOD]: DEVICE_IOS,
  [DEVICE_IPAD]: DEVICE_IOS,
};

export const VIDEO_TYPE_VOD_360 = "VOD_360";
export const VIDEO_TYPE_LIVE = "LIVE";
export const VIDEO_TYPE_TIIVII_LIVE = "TIIVIILIVE"
export const VIDEO_TYPE_LIVE_TIIVII = "LIVE_TIIVII";
export const VIDEO_TYPE_EXTERNAL_LIVE = "EXTERNAL-LIVE";
export const VIDEO_TYPE_EXTERNAL_IFRAME = "EXTERNAL-IFRAME";
export const VIDEO_TYPE_VOD_FORKED = "VOD_FORKED";
export const VIDEO_TYPE_VOD_CONTAINER = "CONTAINER";
export const VIDEO_TYPE_VOD_AR = "AR";
export const VIDEO_TYPE_VOD_VR = "VR";
export const VIDEO_TYPE_BASICVIDEO = "BASICVIDEO";

// Editorial Tags Priority Constants
export const EDITORIAL_TAG_DIRECTO = "directo";
export const EDITORIAL_TAG_PUBLICADO = "publicado";
export const EDITORIAL_TAG_LIVE = "live";
export const EDITORIAL_TAG_PUBLISHED = "published";

export const EDITORIAL_TAGS_PRIORITY = [
  EDITORIAL_TAG_DIRECTO,
  EDITORIAL_TAG_PUBLICADO,
  EDITORIAL_TAG_LIVE,
  EDITORIAL_TAG_PUBLISHED
];


export const MAX_NOTIFICATIONS = 9;
export const DISPLAY_NOTIFICATIONS = `${MAX_NOTIFICATIONS}+`;


export const TIME_ZONE_EUROPE_BERLIN = "Europe/Berlin";
export const DEFAULT_TIME_ZONE = TIME_ZONE_EUROPE_BERLIN;

export const SHOW_LENGUAJE = "lenguaje";
export const SHOW_SEARCH = "search";
// Estado de navegación que manda la lupa del menú para que /buscar enfoque el campo de texto
export const FOCUS_SEARCH_INPUT_STATE = "focusSearchInput";
export const ESCAPE_KEY = "Escape";

export const TYPE_BANNER_CONVERSION = {
  circular: WIDGET_TYPE_CIRCULAR,
  banner: TYPE_BANNER_BANNER,
  "banner-v2": WIDGET_TYPE_BANNER,
  "grid-v2": WIDGET_TYPE_GRID,
  widget_progress: TYPE_BANNER_PROGRESS,
  "widget_progress-v2": WIDGET_TYPE_PROGRESS,
  featured: WIDGET_TYPE_FEATURED,
  "featured-v2": WIDGET_TYPE_FEATURED_V2,
  banner_large: TYPE_BANNER_BANNER_LARGE,
  "directo-v2": WIDGET_TYPE_LIVE_V2,
  live: TYPE_BANNER_LIVE,
  "live-2": TYPE_BANNER_LIVE_2,
  "live-vertical": TYPE_BANNER_LIVE_VERTICAL,
  "filter-list": WIDGET_TYPE_GRID_GROUP,
  filter: WIDGET_TYPE_GRID,
  poster: TYPE_BANNER_POSTER,
  "poster-v2": WIDGET_TYPE_POSTER,
  news: TYPE_BANNER_TEXT,
  DESTACADO: WIDGET_TYPE_HIGHLIGHT,
  LIVE: TYPE_BANNER_LIVE,
  BANNER: TYPE_BANNER_BANNER,
  "FILTER-LIST": WIDGET_TYPE_GRID_GROUP,
  DEFAULT_TYPE: WIDGET_TYPE_GRID,
  "list-screen-grid": WIDGET_TYPE_LIST_SCREEN_GRID,
  "list-screen-v2": WIDGET_TYPE_LIST_SCREEN_V2,
  "banner-content": WIDGET_TYPE_BANNER_CONTENT,
};

export const widgetTypesWithoutSeparateSpace = [
  WIDGET_TYPE_HIGHLIGHT.toUpperCase(),
  WIDGET_TYPE_GRID.toUpperCase(),
  WIDGET_TYPE_LIVE_V2.toUpperCase(),
  WIDGET_TYPE_POSTER.toUpperCase(),
  WIDGET_TYPE_PROGRESS.toUpperCase(),
  WIDGET_TYPE_BANNER.toUpperCase(),
  WIDGET_TYPE_FEATURED_V2.toUpperCase(),
  WIDGET_TYPE_FEATURED.toUpperCase(),
  WIDGET_TYPE_BANNER_CLICK.toUpperCase(),
  WIDGET_TYPE_LIST_SCREEN_GRID.toUpperCase(),
  WIDGET_TYPE_BANNER_CONTENT.toUpperCase(),
  WIDGET_TYPE_HTML.toUpperCase()
];

export const LOCAL_STORAGE_KEY__LOCALE = "petisgo-locale";
export const LOCAL_STORAGE_KEY__SKIP_ONBOARDING = "petisgo-skip-onboarding";
export const LOCAL_STORAGE_KEY__SECTION_ID = "OTT-SectionID";
export const LOCAL_STORAGE_KEY__SECTION_URL = "OTT-URLSection";
export const LOCAL_STORAGE_KEY__SELECTED_SECTION = "OTT-Section";

export const INTERFACE_MAIN = "MAIN";
export const INTERFACE_LOGGED_IN = "LOGADO";
export const INTERFACE_PETISGO_ADULT = "Interfaz adultos"

export const SECTION_TYPE_SCREEN = "screen";

// Menu Constants - Constantes para funcionalidad del menú lateral condicional
export const MENU_HOME_PATHS = ['/home', '/'];
export const MENU_DESKTOP_BREAKPOINT = 768;
export const MENU_ORION_CSS_CLASS = 'Menu orion-home-desktop';
export const MENU_DEFAULT_CSS_CLASS = 'Menu';
export const MENU_BODY_ACTIVE_CLASS = 'orion-home-active';

// Age Restriction Constants - Constantes para restricciones de edad
export const AGE_RESTRICTION_7_PLUS = '+7';
export const AGE_RESTRICTION_12_PLUS = '+12';
export const AGE_RESTRICTION_16_PLUS = '+16';
export const AGE_RESTRICTION_18_PLUS = '+18';

export const MENU_DISPLAY_LATERAL = "lateral";
export const MENU_DISPLAY_TOP = "top";
export const MENU_DISPLAY_VALUES = [MENU_DISPLAY_LATERAL, MENU_DISPLAY_TOP];
export const MENU_DISPLAY_DEFAULT = MENU_DISPLAY_LATERAL;

export const PLAYER_VERSION_V1 = "v1";
export const PLAYER_VERSION_V2 = "v2";
export const PLAYER_VERSION_VALUES = [PLAYER_VERSION_V1, PLAYER_VERSION_V2];
export const PLAYER_VERSION_LEGACY = PLAYER_VERSION_V1;
export const PLAYER_VERSION_DEFAULT = PLAYER_VERSION_LEGACY;

export const URL_PATH_NOTIFICATIONS = "/notifications";
